import { useContext, useState, createContext } from "react";
import { isAuthenticated } from "apiHandler/actions/auth";

const UserDataContext = createContext();
const UserDataUpdateContext = createContext();

export const useUserData = () => {
  return useContext(UserDataContext);
};

export const useUpdateUserData = () => {
  return useContext(UserDataUpdateContext);
};

export const UserDataProvider = ({ children }) => {
  const [userData, setUserData] = useState(isAuthenticated() || null);

  const updateUserData = (data) => {
    if (data) {
      setUserData((userData) => ({ ...userData, ...data }));
    } else setUserData(data);
    if (typeof window !== "undefined" && data) {
      localStorage.setItem(
        "auth_data",
        JSON.stringify({ ...userData, ...data })
      );
    }
  };

  return (
    <UserDataContext.Provider value={userData}>
      <UserDataUpdateContext.Provider value={updateUserData}>
        {children}
      </UserDataUpdateContext.Provider>
    </UserDataContext.Provider>
  );
};
